// Amplify Auth config.
// For the new fashionsnap-stag-users Cognito pool we use native email/password
// (USER_SRP) sign-in via withAuthenticator, so the hosted-UI / Google OAuth block
// is only included when an OAuth domain is explicitly configured. When
// REACT_APP_DOMAIN is unset (the real-login stag setup) the oauth block is omitted
// and the default Amplify email/password sign-in screen is used.

const config = {
    Auth: {
        region: process.env.REACT_APP_REGION || 'ap-northeast-2',
        userPoolId: process.env.REACT_APP_USER_POOL_ID,
        userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID,
    },
};

// Only wire the hosted-UI / Google OAuth flow when a Cognito domain is provided.
if (process.env.REACT_APP_DOMAIN) {
    config.Auth.oauth = {
        domain: process.env.REACT_APP_DOMAIN,
        scope: ['email', 'openid', 'profile'],
        redirectSignIn: process.env.REACT_APP_SIGNIN_URL,
        redirectSignOut: process.env.REACT_APP_SIGNOUT_URL,
        responseType: 'token', // or 'token', note that REFRESH token will only be generated when the responseType is code
    };
}

export default config;
